import React from 'react';
import BaseIcon from './BaseIcon';


const ReverseIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M5 0L8 4H6V10H4V4H2L5 0ZM11 16L8 12L10 12L10 6L12 6L12 12H14L11 16Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </g>
  </BaseIcon>
);

export default ReverseIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/ReverseIcon.jsx